<template>
  <v-container grid-list-md v-show="false">
    <v-layout row wrap id="printInscricoes" style="text-align: center; margin-top: 12px">
      <!-- <div
        v-for="item in this.inscritos"
        :key="item.id"
        style="display: inline-block"
      >
        <v-flex xs6 sm6 md6 lg6 style="margin-left: 13px; margin-top: 6mm">
          <p><b>{{item.nome.toUpperCase()}}</b></p>
          <p>{{item.idade}} anos</p>
          <p>{{item.telefone}}</p>
          <p>Responsável: {{item.nomeResponsavel.toUpperCase()}}</p>
        </v-flex>
      </div> -->
      <v-flex
        xs5 sm5 md5 lg5
        v-for="item in inscritos"
        :key="item.id"
        :style="item.css"
      >
        <p style="font-size: 34px; margin: 0px"><b>{{item.nome.toUpperCase().split(' ').slice(0,1).join(' ')}}</b></p>
        <!-- <p v-if="item.crachaNome" style="font-size: 34px; margin: 0px"><b>{{item.crachaNome.toUpperCase().split(' ').slice(0,1).join(' ')}}</b></p> -->
        <p style="font-size: 34px; margin: 0px"><b>{{item.telefone}}</b></p>
      </v-flex>
      <!-- <br>
      <v-flex xs5 sm5 md5 lg5 style="margin-left: 25px; margin-top: 6mm">
        <p><b>Teste Teste</b></p>
        <p>10 anos</p>
        <p>(83) 98833-5577</p>
        <p>Responsável: Teste Teste</p>
      </v-flex>
      <br>
      <v-flex xs6 sm6 md6 lg6 style="margin-left: 13px; margin-top: 25px">
        <p><b>Teste Teste</b></p>
        <p>10 anos</p>
        <p>(83) 98833-5577</p>
        <p>Responsável: Teste Teste</p>
      </v-flex>
      <br>
      <v-flex xs5 sm5 md5 lg5 style="margin-left: 25px; margin-top: 25px">
        <p><b>Teste Teste</b></p>
        <p>10 anos</p>
        <p>(83) 98833-5577</p>
        <p>Responsável: Teste Teste</p>
      </v-flex>
      <br>
      <v-flex xs6 sm6 md6 lg6 style="margin-left: 13px; margin-top: 25px">
        <p><b>Teste Teste</b></p>
        <p>10 anos</p>
        <p>(83) 98833-5577</p>
        <p>Responsável: Teste Teste</p>
      </v-flex>
      <br>
      <v-flex xs5 sm5 md5 lg5 style="margin-left: 25px; margin-top: 25px">
        <p><b>Teste Teste</b></p>
        <p>10 anos</p>
        <p>(83) 98833-5577</p>
        <p>Responsável: Teste Teste</p>
      </v-flex>
      <br>
      <v-flex xs6 sm6 md6 lg6 style="margin-left: 13px; margin-top: 25px">
        <p><b>Teste Teste</b></p>
        <p>10 anos</p>
        <p>(83) 98833-5577</p>
        <p>Responsável: Teste Teste</p>
      </v-flex>
      <br>
      <v-flex xs5 sm5 md5 lg5 style="margin-left: 25px; margin-top: 25px">
        <p><b>Teste Teste</b></p>
        <p>10 anos</p>
        <p>(83) 98833-5577</p>
        <p>Responsável: Teste Teste</p>
      </v-flex>
      <br>
      <v-flex xs6 sm6 md6 lg6 style="margin-left: 13px; margin-top: 25px">
        <p><b>Teste Teste</b></p>
        <p>10 anos</p>
        <p>(83) 98833-5577</p>
        <p>Responsável: Teste Teste</p>
      </v-flex>
      <br>
      <v-flex xs5 sm5 md5 lg5 style="margin-left: 25px; margin-top: 25px">
        <p><b>Teste Teste</b></p>
        <p>10 anos</p>
        <p>(83) 98833-5577</p>
        <p>Responsável: Teste Teste</p>
      </v-flex>
      <br>
      <v-flex xs6 sm6 md6 lg6 style="margin-left: 13px; margin-top: 25px">
        <p><b>Teste Teste</b></p>
        <p>10 anos</p>
        <p>(83) 98833-5577</p>
        <p>Responsável: Teste Teste</p>
      </v-flex>
      <br>
      <v-flex xs5 sm5 md5 lg5 style="margin-left: 25px; margin-top: 25px">
        <p><b>Teste Teste</b></p>
        <p>10 anos</p>
        <p>(83) 98833-5577</p>
        <p>Responsável: Teste Teste</p>
      </v-flex>
      <br>
      <v-flex xs6 sm6 md6 lg6 style="margin-left: 13px; margin-top: 25px">
        <p><b>Teste Teste</b></p>
        <p>10 anos</p>
        <p>(83) 98833-5577</p>
        <p>Responsável: Teste Teste</p>
      </v-flex>
      <br>
      <v-flex xs5 sm5 md5 lg5 style="margin-left: 25px; margin-top: 25px">
        <p><b>Teste Teste</b></p>
        <p>{{this.idade}} + "anos"</p>
        <p>(83) 98833-5577</p>
        <p>Responsável: Teste Teste</p>
      </v-flex>
      <br>
      <v-flex xs6 sm6 md6 lg6 style="margin-left: 13px; margin-top: 25px">
        <p><b>Teste Teste</b></p>
        <p>10 anos</p>
        <p>(83) 98833-5577</p>
        <p>Responsável: Teste Teste</p>
      </v-flex>
      <br>
      <v-flex xs5 sm5 md5 lg5 style="margin-left: 25px; margin-top: 25px">
        <p><b>Teste Teste</b></p>
        <p>10 anos</p>
        <p>(83) 98833-5577</p>
        <p>Responsável: Teste Teste</p>
      </v-flex>
      <br>
      <v-flex xs6 sm6 md6 lg6 style="margin-left: 13px; margin-top: 25px">
        <p><b>Teste Teste</b></p>
        <p>10 anos</p>
        <p>(83) 98833-5577</p>
        <p>Responsável: Teste Teste</p>
      </v-flex>
      <br>
      <v-flex xs5 sm5 md5 lg5 style="margin-left: 25px; margin-top: 25px">
        <p><b>Teste Teste</b></p>
        <p>10 anos</p>
        <p>(83) 98833-5577</p>
        <p>Responsável: Teste Teste</p>
      </v-flex>
      <br>
      <v-flex xs6 sm6 md6 lg6 style="margin-left: 13px; margin-top: 25px">
        <p><b>Teste Teste</b></p>
        <p>10 anos</p>
        <p>(83) 98833-5577</p>
        <p>Responsável: Teste Teste</p>
      </v-flex>
      <br>
      <v-flex xs5 sm5 md5 lg5 style="margin-left: 25px; margin-top: 25px">
        <p><b>Teste Teste</b></p>
        <p>10 anos</p>
        <p>(83) 98833-5577</p>
        <p>Responsável: Teste Teste</p>
      </v-flex> -->
    </v-layout>
  </v-container>    
</template>

<script>
  import PH from 'print-html-element'
  // import axios from 'axios'
  // import { baseApiUrl } from '@/global'
  export default {
    data () {
      return {
        eventoId: '',
        eventos: [],
        inscritos: [],
        quebra20: false,
        quebra40: false,
        quebra60: false,
        quebra80: false,
        quebra100: false,
        quebra120: false,
        quebra140: false,
      }
    },

    mounted : function() {

    },

    methods: {
      print() {
        PH.printElement(document.getElementById('printInscricoes'))
      },

      preparaImpressao (conteudo) {
        //this.inscritos = JSON.parse(sessionStorage.getItem('Inscritos'))
        this.inscritos = conteudo
        let posicao = "topEsquerda"
        var count = 0
        for (let i = 0; i < this.inscritos.length; i++) {
          if (posicao == "topEsquerda") {
            this.inscritos[i].css = "margin-left: 13px; height: 80px; margin-bottom: 19px"
            posicao = "topDireita"
          } else if (posicao == "topDireita") {
            this.inscritos[i].css = "margin-left: 90px; height: 80px; margin-bottom: 19px"
            posicao = "esquerda"
          } else if (posicao == "esquerda") {
            this.inscritos[i].css = "margin-left: 13px; margin-bottom: 19px; height: 80px"
            posicao = "direita"
          } else {
            this.inscritos[i].css = "margin-left: 90px; margin-bottom: 19px; height: 80px"
            posicao = "esquerda"
          }
          count++
          if (count == 20) {
            this.quebra20 = true
          }
          if (count == 40) {
            this.quebra40 = true
          }
          if (count == 60) {
            this.quebra60 = true
          }
          if (count == 80) {
            this.quebra80 = true
          }
          if (count == 100) {
            this.quebra100 = true
          }
          if (count == 120) {
            this.quebra120 = true
          }
          if (count == 140) {
            this.quebra140 = true
          }
        }
      }
    }
  }
</script>

<style>
  .tituloProposta{
    font-size:15px;
    font-weight:700;
    color:#797a7a;
    margin-bottom:5px;  
    text-align: center;  
    border: 1px solid; 
    border-color: #004899;
    border-radius: 10px;
    padding: 8px;
  }

  .flexProposta {
    display: flex;
    flex-wrap: nowrap;
  }

  .item {
    margin: 10px auto;
    font-size:18px;
    color: #004899;
  }

  .containerProposta {
    font-size:15px;
    min-width: auto;
    margin: 5px 20px 0 0;
  }

  .itemValor{
    margin: 5px auto;
    font-size:15px;
    color:#797a7a;
  }

  .flex-container {
    display: flex;
    flex-wrap: nowrap;
  }

  .flex-container > div {
    min-width: auto;
    margin: 5px 20px auto auto;
    font-size:15px;
    color:#797a7a;
  }

  @media print {
    .page-break {
      margin-top: 1rem;
      display: block;
      page-break-before: auto;
    }
  }
</style>